import { ReactNode } from "react";
import { twMerge } from "tailwind-merge";

export function Board({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  return (
    <div
      className={twMerge(
        "grid grid-flow-col auto-cols-[minmax(300px,1fr)] gap-x-4 overflow-x-auto",
        className,
      )}
    >
      {children}
    </div>
  );
}
